// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_navigationWrapper__ss0Y8 .styles_navigation__lOZyO {
  display: flex;
  gap: 1rem;
  list-style-type: none;
}
.styles_navigationWrapper__ss0Y8 .styles_navigation__lOZyO.styles_vertical__kyVpN {
  flex-direction: column;
}
.styles_navigationWrapper__ss0Y8 .styles_navigation__lOZyO li a {
  font-weight: 500;
  transition: opacity 0.2s ease-in-out;
}
.styles_navigationWrapper__ss0Y8 .styles_navigation__lOZyO li a:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/navigation/styles.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAAJ;AAEI;EACE,sBAAA;AAAN;AAIM;EACE,gBAAA;EACA,oCAAA;AAFR;AAIQ;EACE,YAAA;AAFV","sourcesContent":[".navigationWrapper {\n  .navigation {\n    display: flex;\n    gap: 1rem;\n    list-style-type: none;\n\n    &.vertical {\n      flex-direction: column;\n    }\n\n    li {\n      a {\n        font-weight: 500;\n        transition: opacity 0.2s ease-in-out;\n\n        &:hover {\n          opacity: 0.8;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationWrapper": `styles_navigationWrapper__ss0Y8`,
	"navigation": `styles_navigation__lOZyO`,
	"vertical": `styles_vertical__kyVpN`
};
export default ___CSS_LOADER_EXPORT___;
